export const checkInResponse = {
  "data": {
    "amp_url": null,
    "api_url": "http://hotel-api.test/content-api/collections/check-in/entries/a989ea8c-29a6-4b57-a42e-382e557b191a",
    "collection": {
      "id": "check-in",
      "title": "Check-in",
      "api_url": null
    },
    "content": "",
    "date": "2020-08-26T23:04:11.000000Z",
    "description": "<h1>This is a heading 1</h1><h2>This is a heading 2</h2><h3>This is a heading 3</h3><p>Je bent er! Tijd om je in te checken bij onze balie. Denk er aan om de volgende dingen mee te nemen:</p><ul> <li>Reserveringsnummer</li><li>Paspoort</li><li>Credit Card</li><li>Aanvullende vereisten</li></ul><p>Je loopt zo langs ons restaurant, wist je dat we ook aan in-room dining doen? Zo kun je gemakkelijk in je eigen cabin genieten van ons eten.</p><ol> <li>Reserveringsnummer</li><li>Paspoort</li><li>Credit Card</li><li>Aanvullende vereisten</li><li>Reserveringsnummer</li><li>Paspoort</li><li>Credit Card</li><li>Aanvullende vereisten</li><li>Reserveringsnummer</li><li>Paspoort</li><li>Credit Card</li><li>Aanvullende vereisten</li></ol><blockquote>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.</blockquote><p>Je bent er! Tijd om je in te checken bij onze balie. Denk er aan om de volgende dingen mee te nemen:</p><ul> <li>Reserveringsnummer</li><li>Paspoort</li><li>Credit Card</li><li>Aanvullende vereisten</li></ul>",
    "edit_url": "http://hotel-api.test/cp/collections/check-in/entries/a989ea8c-29a6-4b57-a42e-382e557b191a/welcome-to-our-park-it-s-time-to-check-in",
    "id": "a989ea8c-29a6-4b57-a42e-382e557b191a",
    "image": {
      "id": "images::checkin/suite-room.jpg",
      "url": "http://hotel-api.test/storage/checkin/suite-room.jpg",
      "permalink": "http://hotel-api.test/storage/checkin/suite-room.jpg",
      "api_url": "http://hotel-api.test/content-api/assets/images/checkin/suite-room.jpg"
    },
    "is_entry": true,
    "label": "ENTER THE UNBOUND",
    "last_modified": "2020-08-26T23:04:11.000000Z",
    "permalink": "http://hotel-api.test",
    "private": false,
    "published": true,
    "slug": "welcome-to-our-park-it-s-time-to-check-in",
    "title": "Welcome to our Park. It’s time to check in!",
    "updated_at": "2020-08-26T23:04:11.000000Z",
    "updated_by": {
      "id": 1,
      "name": "Chimp",
      "email": "info@chimp.nl",
      "api_url": "http://hotel-api.test/content-api/users/1"
    },
    "uri": null,
    "url": "/"
  }
}
